import { createRevisionClassResource, RevisionActions } from "../../revision";
import { RevisionItem } from "../RevisionItem";
import { ResourceItem } from "../ResourceItem";
import {
  getDiff,
  itemApiField,
  apiField,
  constructFromApiData,
  getApiPostData,
  revisionItemApiField,
  revisionApiField,
} from "../ResourceItemMetadata";
import { Resource } from "../../resource";
import { getDumpAction } from "../../dump";

export interface Producent {
  nazwa: string;
  krajPochodzenia: { nazwa: string; id: number };
}

export class Wyrob extends RevisionItem {
  @apiField()
  name!: string;

  @revisionApiField()
  produkt:
    | (RevisionItem & {
        productGroup: ResourceItem;
        opis: string;
        obiektZastosowania: ResourceItem[];
        czescBudynku: ResourceItem[];
        podloze: ResourceItem[];
        wnetrze: boolean;
        zewnetrze: boolean;
        podWoda: boolean;
        przeciwwskazania: string;
        wlasciwosciUzytkowe: string;
      })
    | null = null;
  @itemApiField(ResourceItem)
  brand: ResourceItem | null = null;
  @apiField()
  nazwaHandlowa: string = "";

  @apiField()
  opisTechniczny: string = "";
  @itemApiField(ResourceItem)
  jednostkaSprzedazy: ResourceItem | null = null;
  @apiField()
  ceNr: string = "";
  @apiField()
  dopNr: string = "";
  @apiField()
  atestPzh: boolean = false;

  @apiField({ readOnly: true })
  activeAsortymentSet: ResourceItem[] | null = null;

  toString() {
    return this.id!.toString();
  }

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return { ...getApiPostData(this), ...super.getPostData() };
  }

  getDiff(other: this) {
    return getDiff(this, other);
  }
}

const dumpLabels = [
  { key: "name", header: "indeksWyrobu" },
  { key: "produktName", header: "indeksProduktu" },
  { key: "brandStr", header: "markaHandlowa" },
  { key: "nazwaHandlowa", header: "nazwaHandlowa" },
  { key: "opisTechniczny", header: "opisTechniczny" },
  { key: "jednosktaSprzedazyStr", header: "jednosktaSprzedazy" },
  { key: "ceNr", header: "ceNr" },
  { key: "dopNr", header: "dopNr" },
  { key: "productGroupStr", header: "grupaProduktowa" },
  { key: "wZakresieProdukcji", header: "wZakresieProdukcji" },
  { key: "dopuszczonyDoProdukcji", header: "dopuszczonyDoProdukcji" },
];

export const wyrobResource: Resource<RevisionActions> = (client) => ({
  ...createRevisionClassResource("plm/wyrob/", Wyrob)(client),
  dump: getDumpAction("plm/wyrob/", dumpLabels)(client),
});
